import { render, staticRenderFns } from "./sort-picker.vue?vue&type=template&id=12c5d008&scoped=true&"
import script from "./sort-picker.vue?vue&type=script&lang=js&"
export * from "./sort-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c5d008",
  null
  
)

export default component.exports